import { I18n } from "react-redux-i18n";
import { getPaymentMethod } from "../tableMatePaid";

var sam4s = {
    5: "A00",
    18: "B00",
    27: "C00",
    s5: "A00",
    s18: "B00",
    s27: "C00",
    null: "E00",
    undefined: "E00",
    0: "D00"
};
var paymentMethods = {
    "cash": "1",
    "card": "2",
    "hellopay": "2",
    "teya": "2",
    "online": "2",
    "bizpay": "2",
    "paynance": "2",
    "utalvany": "16",
}
export const generate_sam4s2 = (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => {
    var url = "";

    url = "PTG|1";

    var services = {};

    Object.values(amounts).sort((a, b) => a.entryOrder - b.entryOrder).filter(category => category.amount + category.service_amount).forEach(category => {
        if (category.amount) {
            //eslint-disable-next-line no-useless-concat
            url += "\\1|" + category.name + " " + "||" + ("" + category.amount).replace(",", ".") + "|" + category.count + "|db|" + (category.count * category.amount) + "|" + sam4s[category.vat] + "||";
        }
        if (category.service_amount > 0) {
            if (!services[category.vat]) {
                services[category.vat] = 0;
            }
            services[category.vat] += category.service_amount * category.count;
        }
    });

    Object.keys(services).forEach(key => {
        url += "\\1|" + (services[key] > 2 ? I18n.t("admin_local.fiscat_service_fee") + " (" + I18n.t("admin_local.vat") + " " + key + "% ÁFA)" : I18n.t("admin_local.rounding")) + "||" + ("" + services[key]).replace(",", ".") + "|1|db|" + ("" + services[key]).replace(",", ".") + "|" + sam4s["s" + key] + "||";
    });




    types.filter(t => t.amount > 0).forEach((t, ind) => {
        if (ind > 0)
            url += "|";
        const paymentMethod = getPaymentMethod(t.type);

        //var roundFunction = auth.myStatus.restaurant_base_currency["javaScriptRoundFunction"];
        var amount = t.amount;
        // eslint-disable-next-line no-eval
        //amount = eval(roundFunction.replace("amount", t.amount));

        if (t.currency === "EUR" && paymentMethod.method.type === "cash")
            url += "\\6|1|" + Math.round(100 * t.amount) / 100;
        else
            url += "\\6|" + paymentMethods[paymentMethod.method.type] + "|" + amount;
    });

    url += "\r\n";

    if (types.filter(t => t.amount > 0).length === 0) url = "";

    url += "%/%{pattern:'PTG\\\\|1\\\\|(\\\\d+/\\\\d+)\\\\|.*', antipattern: '(Nap zárva!|Kifogyott a papír a nyomtatóból!|Bizonylatmegszakítás folyamatban, vagy bizonylatmegszakítás szükséges!)',timeout:10000, antipatterngroup: 1}"

    console.log(url);
    def.resolve(url);
}

export const storno_sam4s2 = (data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    data.originalDate = `${now.getFullYear()}.${pad(now.getMonth() + 1)}.${pad(now.getDate())}.${pad(now.getHours())}:${pad(now.getMinutes())}`;

    //PTG|1\7|0|aaaaa|1192|Budapest|Szőnyi öz 2|-|-||2025.03.13 09:26|NY/Y22700020/0004/00014|S1;

    var url = `PTG|1\\7|0|${data.customerName}|${data.customerPostCode}|${data.customerTown}|${data.customerAddress}|-|-||${data.originalDate}|NY/${data.ap}/${data.receiptNumber}|S${data.reason}`;

    var services = {};

    Object.values(amounts).sort((a, b) => a.entryOrder - b.entryOrder).filter(category => category.amount + category.service_amount).forEach(category => {
        if (category.amount) {
            //eslint-disable-next-line no-useless-concat
            url += "\\1|" + category.name + " " + "||" + ("" + category.amount).replace(",", ".") + "|" + category.count + "|db|" + (category.count * category.amount) + "|" + sam4s[category.vat] + "||";
        }
        if (category.service_amount > 0) {
            if (!services[category.vat]) {
                services[category.vat] = 0;
            }
            services[category.vat] += category.service_amount * category.count;
        }
    });
    types.filter(t => t.amount > 0).forEach((t, ind) => {
        if (ind > 0)
            url += "|";
        const paymentMethod = getPaymentMethod(t.type);

        //var roundFunction = auth.myStatus.restaurant_base_currency["javaScriptRoundFunction"];
        var amount = t.amount;
        // eslint-disable-next-line no-eval
        //amount = eval(roundFunction.replace("amount", t.amount));

        if (t.currency === "EUR" && paymentMethod.method.type === "cash")
            url += "\\6|1|" + Math.round(100 * t.amount) / 100;
        else
            url += "\\6|" + paymentMethods[paymentMethod.method.type] + "|" + amount;
    });


    //PTG|1\7|0|Gombos Elemér|1111|Budapest|Fogarasi|út|117||2022.04.10.12:10|NY/A15600001/0001/00021|S1\1|tükörfúrógép       ||200 |1|db|200 |A00||RÚGÓS tükörfúrógép\6|1|200
    //PTG|1\7|0|AA           |  AA|AA      |AA      |- |-  ||2026.01.09.18:57|NY/Y22700053/0002/00007|S1\1|Rémséges sajtfala  ||2490|1|db|2490|A00||\6|1|2490
    url += "%/%{pattern:'PTG\\\\|2\\\\|S\\\\/.\\\\d\\\\d\\\\d\\\\d\\\\d\\\\d\\\\d\\\\d\\\\/(\\\\d\\\\d\\\\d\\\\d\\\\/\\\\d\\\\d\\\\d\\\\d\\\\d)\\\\.*', antipattern: '(Nap zárva!|Kifogyott a papír a nyomtatóból!|Bizonylatmegszakítás folyamatban, vagy bizonylatmegszakítás szükséges!)',timeout:20000, antipatterngroup: 1}";

    def.resolve(url + "\r\n");
}

export const refund_sam4s2 = (data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    data.originalDate = `${now.getFullYear()}.${pad(now.getMonth() + 1)}.${pad(now.getDate())}.${pad(now.getHours())}:${pad(now.getMinutes())}`;

    //PTG|1\7|0|aaaaa|1192|Budapest|Szőnyi öz 2|-|-||2025.03.13 09:26|NY/Y22700020/0004/00014|S1;

    var url = `PTG|1\\7|1|${data.customerName}|${data.customerPostCode}|${data.customerTown}|${data.customerAddress}|-|-||${data.originalDate}|NY/${data.ap}/${data.receiptNumber}|V${data.reason}`;

    var services = {};

    Object.values(amounts).sort((a, b) => a.entryOrder - b.entryOrder).filter(category => category.amount + category.service_amount).forEach(category => {
        if (category.amount) {
            //eslint-disable-next-line no-useless-concat
            url += "\\1|" + category.name + " " + "||" + ("" + category.amount).replace(",", ".") + "|" + category.count + "|db|" + (category.count * category.amount) + "|" + sam4s[category.vat] + "||";
        }
        if (category.service_amount > 0) {
            if (!services[category.vat]) {
                services[category.vat] = 0;
            }
            services[category.vat] += category.service_amount * category.count;
        }
    });
    types.filter(t => t.amount > 0).forEach((t, ind) => {
        if (ind > 0)
            url += "|";
        const paymentMethod = getPaymentMethod(t.type);

        //var roundFunction = auth.myStatus.restaurant_base_currency["javaScriptRoundFunction"];
        var amount = t.amount;
        // eslint-disable-next-line no-eval
        //amount = eval(roundFunction.replace("amount", t.amount));

        if (t.currency === "EUR" && paymentMethod.method.type === "cash")
            url += "\\6|1|" + Math.round(100 * t.amount) / 100;
        else
            url += "\\6|" + paymentMethods[paymentMethod.method.type] + "|" + amount;
    });


    //PTG|1\7|0|Gombos Elemér|1111|Budapest|Fogarasi|út|117||2022.04.10.12:10|NY/A15600001/0001/00021|S1\1|tükörfúrógép       ||200 |1|db|200 |A00||RÚGÓS tükörfúrógép\6|1|200
    //PTG|1\7|0|AA           |  AA|AA      |AA      |- |-  ||2026.01.09.18:57|NY/Y22700053/0002/00007|S1\1|Rémséges sajtfala  ||2490|1|db|2490|A00||\6|1|2490
    url += "%/%{pattern:'PTG\\\\|3\\\\|V\\\\/.\\\\d\\\\d\\\\d\\\\d\\\\d\\\\d\\\\d\\\\d\\\\/(\\\\d\\\\d\\\\d\\\\d\\\\/\\\\d\\\\d\\\\d\\\\d\\\\d)\\\\.*', antipattern: '(Nap zárva!|Kifogyott a papír a nyomtatóból!|Bizonylatmegszakítás folyamatban, vagy bizonylatmegszakítás szükséges!)',timeout:20000, antipatterngroup: 1}";

    def.resolve(url + "\r\n");
}

export const cashin_sam4s2 = (reason, amount) => {
    return `PTG|1\\9|0|1|${reason}|${amount}\r\n`;
}

export const cashout_sam4s2 = (reason, amount) => {
    return `PTG|1\\9|1|1|${reason}|${amount}\r\n`;
}

export const dayOpen_sam4s2 = (amount) => {
    return { text: `PTG|1|\\10|${amount}\r\n` };
}
export const dayClose_sam4s2 = () => {
    return { text: `PTG|1|\\11\r\n` };
}
